import React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import OrderTcr from "../orderTcr";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../../common/models/httpError";
import Form from "../../../../../common/components/shared/form/form";
import {routingAddresses} from "../../../../../helpers/routing";
import {Api} from "../../../../../helpers/api";
import {HttpError} from "../../../../../common/components/shared/httpError/httpError";
import i18n from "../../../../../i18n/i18n";
import "./modifyTcr.scss";
import {storesContext} from "../../../../../common/stores/stores";
import {ITcrStore} from "../../../../stores/tcrStore";
import {RouteParamsModel} from "../../../../../common/models/routeParams";
import {Utils} from "../../../../../helpers/utils";
import TcrUtils from "../../../../../helpers/tcrUtils";
import {observer} from "mobx-react";
import {TcrService} from "../../../../services/tcrService";
import Notification from "../../../../../common/components/shared/notification/notification";

interface ModifyTcrState {
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isSubmitButtonBlocked: boolean;
    id: string;
    isSuccess: boolean;
    responseTcrData: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class ModifyTcr extends React.Component <RouteComponentProps, ModifyTcrState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            response: undefined,
            isSubmitButtonBlocked: false,
            id: "",
            isSuccess: false,
            responseTcrData: undefined
        };
    }

    async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;
        this.setState({id: params.id});
    }

    render(): JSX.Element {
        return (
            <div className="modify-tcr">
                {this.state.isSuccess && (
                    <Notification
                        message={
                            <>
                                <b>{i18n.t("transportation.order.tcr.successFirstPart")}</b>
                                {i18n.t("transportation.order.tcr.successSecondPart")}
                            </>
                        }
                        type="success"
                        onClose={() => {
                            this.setState({isSuccess: false});
                        }}
                    />
                )}
                <Form
                    renderContent={this.renderFormContent()}
                    isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                    renderError={this.renderError()}
                    submit={this.submit.bind(this)}
                    backAddress={routingAddresses.order.list}
                />
            </div>
        );
    }

    private renderFormContent(): JSX.Element {
        return <OrderTcr isUpdate={true} response={this.state.responseTcrData}/>;
    }

    private renderError(): JSX.Element | undefined {
        if (!Api.isSuccess(this.state.response)) {
            return (
                <HttpError
                    response={this.state.response}
                    cause={i18n.t("transportation.order.tcr.modifyErrorSuffix")}
                />
            );
        }
    }

    private get isValid() {
        const tcrStore = this.context.tcrStore as ITcrStore;
        return tcrStore.isValid;
    }

    private async submit() {
        const tcrStore = this.context.tcrStore as ITcrStore;

        this.setState({response: undefined});

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});
            const response = await TcrService.modifyTcr(TcrUtils.prepareTcrData(tcrStore));

            this.setState({isSubmitButtonBlocked: false, response});

            if (Api.isSuccess(response)) {
                tcrStore.setIsEdit(false);

                this.setState({
                    isSuccess: true,
                    responseTcrData: (await TcrService.getTcr(tcrStore.orderId))
                });
            }
        }

        Utils.scrollToFirstErrorMessage();
    }
}

export default withRouter(observer(ModifyTcr));

